import { render, staticRenderFns } from "./StatsBestPerformers.vue?vue&type=template&id=7fa40eb0&"
import script from "./StatsBestPerformers.vue?vue&type=script&lang=js&"
export * from "./StatsBestPerformers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports